import PageLayout from 'pages/util/PageLayout'
import React from 'react'
import { PageContainer } from 'shared/components/search'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'shared/components/Tabs'
import { useWorkflowAvailableRoleTabs } from 'shared/components/Workflow/useWorkflowTabs'
import AssignmentTable from './AssignmentTable'
import { useAuthSnowplowPageView } from 'shared/hooks/useSnowPlowPageView'

const WorkflowAssignmentsList: React.FC = () => {
    useAuthSnowplowPageView('Workflow Home', 'Workflow Home Page')

    const tabs = useWorkflowAvailableRoleTabs()

    return (
        <PageLayout>
            <PageContainer>
                <Tabs>
                    <TabList>
                        {tabs.map(({ label, id }) => (
                            <Tab key={`workflow-tab-header-${id}`}>{label}</Tab>
                        ))}
                    </TabList>
                    <TabPanels>
                        {tabs.map(({ type, id }) => (
                            <TabPanel key={`workflow-tab-panel-${id}`}>
                                <AssignmentTable type={type}></AssignmentTable>
                            </TabPanel>
                        ))}
                    </TabPanels>
                </Tabs>
            </PageContainer>
        </PageLayout>
    )
}

export default WorkflowAssignmentsList
